import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HsCardModule, HsIconModule } from '@hsetu/ngui-components';
import { SafeHtml } from '@angular/platform-browser';
import { HsLayerModule } from '@hsetu/ngui-resources';

@Component({
  selector: 'kfm-card',
  imports: [CommonModule, HsCardModule, HsLayerModule, HsIconModule],
  templateUrl: './kfm-card.component.html',
})
export class KfmCardComponent {
  public readonly cardTitle = input<string>('');
  public readonly cardIcon = input<SafeHtml | undefined>(undefined);
}
